var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoSearcWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.25 6.45331C3.25 5.21067 4.25736 4.20331 5.5 4.20331H18.4985C19.7412 4.20331 20.7485 5.21067 20.7485 6.45331L20.7485 9.20331H3.25V6.45331Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0871 10.7033H3.25V19.4533C3.25 20.6959 4.25736 21.7033 5.5 21.7033H11.5595C10.4376 20.5352 9.74805 18.9488 9.74805 17.2014C9.74805 13.6653 12.5716 10.7887 16.0871 10.7033Z",
    fill: "currentColor"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 17.2014C21.25 18.3111 20.8885 19.3364 20.2768 20.1659L21.7835 21.6726C22.0764 21.9655 22.0764 22.4404 21.7835 22.7333C21.4906 23.0262 21.0157 23.0262 20.7228 22.7333L19.2163 21.2268C18.3865 21.8393 17.3605 22.2014 16.25 22.2014C13.4886 22.2014 11.25 19.9628 11.25 17.2014C11.25 14.4399 13.4886 12.2014 16.25 12.2014C19.0114 12.2014 21.25 14.4399 21.25 17.2014Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoSearcWeb);
export default __webpack_public_path__ + "static/media/DuoSearcWeb.d710c1ffca630154f43be947b57ec1eb.svg";
export { ForwardRef as ReactComponent };